export class ScopoProvvedimento{
    id:number;
    descrizione:string;    
}